<script lang="ts">
  import { suggestions, friends } from '../lib/state';
  import { scoreClass } from '../lib/scoring';
  import { promoteSuggestion } from '../lib/entities';
  import { runSuggestions, suggestionsRunning } from '../lib/suggestions';

  const sourceLabel = (source?: string) => {
    if (!source) return 'suggested spot';
    if (source === 'locality') return 'city area';
    if (source.startsWith('sublocality')) return 'district';
    if (source === 'administrative_area_level_2') return 'county area';
    return 'neighborhood';
  };
</script>

{#if $friends.length}
  <div class="section-title" style="margin-top: 24px;">⭐ Ideal neighborhoods <span class="meta">on demand</span></div>
  <button class="secondary" style="width: 100%;" on:click={runSuggestions} disabled={$suggestionsRunning}>
    {$suggestionsRunning ? 'Finding…' : $suggestions.length ? 'Re-run suggestions' : 'Find ideal neighborhoods'}
  </button>
  <p class="ranking-note">
    Scores spots near your people + important places, then refines the top picks with real travel-time and nearby-place data.
    Runs only when you ask. It uses API quota.
  </p>
  {#each $suggestions as sug (`${sug.rank}_${sug.lat}_${sug.lng}`)}
    {@const cls = scoreClass(sug.score)}
    {@const place = sug.neighborhoodName || `Near ${sug.lat.toFixed(4)}, ${sug.lng.toFixed(4)}`}
    <div
      class="rank-card suggestion"
      role="button"
      tabindex="0"
      aria-label={`Promote ${place} to candidate`}
      on:click={() => promoteSuggestion(sug)}
      on:keydown={(e) => e.key === 'Enter' && promoteSuggestion(sug)}
    >
      <div class="rank-card-header">
        <div class="rank-card-rank">⭐ #{sug.rank}</div>
        <div class="rank-card-title">
          <span class="rank-card-name">{place}</span>
          <span class="rank-card-promote-hint">{sug.enriched ? sourceLabel(sug.neighborhoodSource) : 'refining…'}</span>
        </div>
        <div class="rank-card-total">
          <div class="rank-card-total-num {cls}">{sug.enriched ? '' : '~'}{sug.score}</div>
          <div class="rank-card-total-label">{sug.enriched ? 'overall / 100' : 'est. / 100'}</div>
        </div>
      </div>
      {#if sug.enriched}
        <div class="rank-card-section">
          <div class="rank-card-detail">
            <div class="rank-card-detail-item">
              <div class="rank-card-detail-label">point</div>
              <div class="rank-card-detail-value">{sug.lat.toFixed(4)}, {sug.lng.toFixed(4)}</div>
            </div>
            <div class="rank-card-detail-item">
              <div class="rank-card-detail-label">friends</div>
              <div class="rank-card-detail-value">{sug.commute ?? '—'}</div>
            </div>
            <div class="rank-card-detail-item">
              <div class="rank-card-detail-label">daily</div>
              <div class="rank-card-detail-value">{sug.amenity ?? '—'}</div>
            </div>
            <div class="rank-card-detail-item">
              <div class="rank-card-detail-label">weekend</div>
              <div class="rank-card-detail-value">{sug.trip ?? '—'}</div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  {/each}
{/if}
